import { render, staticRenderFns } from "./FChannelImage.vue?vue&type=template&id=23bd27d6&scoped=true&"
import script from "./FChannelImage.vue?vue&type=script&lang=js&"
export * from "./FChannelImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd27d6",
  null
  
)

export default component.exports